export default {
    meta: {
        title: '拓店宝-拓店任务搜索',
        url: '/task',
        urlName: '拓店任务' // 埋点字段，上报归属的模块
    }
};
